import { BackButton } from '@/components/ui/BackButton';

interface TermsOfServiceProps {
  onBack: () => void;
}

export const TermsOfService = ({ onBack }: TermsOfServiceProps) => {
  return (
    <div className="min-h-screen bg-paper">
      <header className="border-b border-border/50">
        <div className="max-w-3xl mx-auto px-6 py-4 flex justify-between items-center">
          <BackButton onClick={onBack} label="Back" srLabel="Return to previous page" />
          <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Terms of Service</span>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-12 space-y-10">
        <div className="text-center mb-12">
          <div className="text-3xl mb-4" style={{ color: 'hsl(38, 40%, 55%)' }}>☽</div>
          <h1 className="font-display text-3xl text-ink mb-2">Terms of Service</h1>
          <p className="text-sm text-muted-foreground">Last updated: February 2026</p>
        </div>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Acceptance of Terms</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            By using Layālī, you agree to these terms. If you do not agree, please do not use the app. Continued use constitutes acceptance of any updates to these terms.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Description of Service</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Layālī is a guided Ramadan companion app offering daily duʿāʾ, journaling, spiritual tracking, and reflections. It is designed to support your personal worship during the blessed month.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">User Responsibilities</h2>
          <ul className="text-sm text-muted-foreground leading-relaxed list-disc list-inside space-y-1.5 pl-2">
            <li>Provide accurate information when creating an account</li>
            <li>Keep your login credentials secure</li>
            <li>Use the app respectfully and in good faith</li>
            <li>Do not attempt to misuse, exploit, or disrupt the service</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Intellectual Property</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            All content within Layālī — including duʿāʾ collections, design, illustrations, and written guidance — is the intellectual property of the Layālī team. You may not reproduce, distribute, or commercially use any content without written permission.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Account Usage & Limitations</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Each account is intended for personal use. We reserve the right to suspend or remove accounts that violate these terms. Guest sessions (email-only) have limited data persistence compared to full accounts.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Disclaimer</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Layālī provides spiritual guidance and reflective tools. It is not a substitute for professional religious counsel, medical advice, or therapy. All duʿāʾ and content are curated with care but are offered as general spiritual support.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Limitation of Liability</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Layālī is provided "as is" without warranties of any kind. We are not liable for any loss of data, interruption of service, or damages arising from the use of the app.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-lg text-ink">Contact</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            For questions about these terms, please contact us at{' '}
            <a href="mailto:hello@layali.app" className="text-gold hover:underline underline-offset-2">
              hello@layali.app
            </a>
          </p>
        </section>
      </main>
    </div>
  );
};
